import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

import NavBar from '../components/NavBar';
import FrTextInput from '../components/FrTextInput';
import UserOptions from '../components/UserOptions';
import FrSelect from '../components/FrSelect';
import FrLoading from '../components/FrLoading';

import api from '../services/api';
import { paramsToObject } from '../utils/functions';
import { colors } from '../utils/vars';
import { mVAL } from '../utils/masks'
import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import FrDatePicker from '../components/FrDatePicker'

const swal = withReactContent(Swal)
const moment = require("moment");

function Contas_Receber(props) {
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('N')
  const [comboCli, setComboCli] = useState([{ value: '', display: '' }])
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])
  const [comboAdesao, setComboAdesao] = useState([{ value: 'A', display: 'Adesão' }, { value: 'M', display: 'Mensalidad' }])

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      let tela = 'Contas a Receber'

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos(tela, 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos(tela, 'Inclusao'))
      }

      setComboFpg(await api.getComboData('formas_pagamento'))

      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/contas_receber?pk_ctr=' + query.codigo).then(async r => {
          if (r.data[0]) {
            setComboCli(await api.getComboDataWhere('clientes', "?nome=" + r.data[0].nomecli))
            if (r.data[0].valor)
              r.data[0].valor = mVAL(r.data[0].valor * 100)
            if (r.data[0].valor_promocao)
              r.data[0].valor_promocao = mVAL(r.data[0].valor_promocao * 100)
            if (r.data[0].valor_pag)
              r.data[0].valor_pag = mVAL(r.data[0].valor_pag * 100)

            setData(r.data[0])

            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'data_venc',
      'fk_fpg',
      'valor',
      'adesao_mensalidade'
    ]
    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (curr == 'fk_fpg')
        fieldName = 'Forma de Pagamento'

      if (curr == 'data_venc')
        fieldName = 'Dt.Vencimento'

      if (curr == 'adesao_mensalidade')
        fieldName = 'Tipo - Adesão/Mensalidade'

      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        let errors = consistData(auxValues)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/contas_receber/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Alterado',
                  text: "O registro foi alterado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi alterado!",
                  icon: 'warning',
                })
              }
            })
          } else {
            api.post('/contas_receber/add', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Adicionado',
                  text: "O registro foi adicionado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
              }
            })
          }
        } else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = async (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'valor':
      case 'valor_promocao':
        auxValues[e.target.name] = e.target.value ? mVAL(e.target.value, 2) : '';
        break;
      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  const handleBlur = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'valor':
      case 'valor_promocao':
        auxValues[e.target.name] = e.target.value ? mVAL(e.target.value, 2) : '';
        break;

      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  }


  return (
    <div className="defaultReg">

      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Conta a Receber</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrSelect
            value={data.fk_cli || ''}
            onChange={handleChange}
            name="fk_cli"
            id="fk_cli"
            label='Titular'
            data={comboCli}
            style={{ width: 425 }}
            disabled
          />

          <FrTextInput
            value={data.fk_cto || ''}
            style={{ width: 120 }}
            color="#333333"
            label="Contrato"
            variant="outlined"
            size="small"
            disabled
          />
          <br />
          <FrDatePicker
            value={(data.data_venc || '').split('T')[0]}
            name="data_venc"
            id="data_venc"
            color="#49573B"
            label="Dt.Vencimento"
            variant="outlined"
            size="small"
            style={{ width: 190 }}
            onChange={handleChange}
            autoFocus
          />

          <FrDatePicker
            value={(data.data_pag || '').split('T')[0]}
            name="data_pag"
            id="data_pag"
            color="#49573B"
            label="Dt.Pagamento"
            variant="outlined"
            size="small"
            style={{ width: 190 }}
            onChange={handleChange}
          />

          <br />
          <FrSelect
            value={data.adesao_mensalidade || ''}
            onChange={handleChange}
            name="adesao_mensalidade"
            id="adesao_mensalidade"
            label='Tipo'
            data={comboAdesao}
            style={{ width: 250 }}
          />

          <FrTextInput
            value={data.num_guia || ''}
            style={{ width: 100 }}
            name="num_guia"
            id="num_guia"
            color="#333333"
            label="Nº Guia"
            variant="outlined"
            size="small"
            onChange={handleChange}
            maxLength={45}
          />

          <FrSelect
            value={data.fk_fpg || ''}
            onChange={handleChange}
            name="fk_fpg"
            id="fk_fpg"
            label='Forma Pagamento'
            data={comboFpg}
            style={{ width: 180 }}
          />
          <br />
          <FrTextInput
            value={data.valor || ''}
            style={{ width: 100 }}
            name="valor"
            id="valor"
            color="#333333"
            label="Valor"
            variant="outlined"
            size="small"
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <FrTextInput
            value={data.valor_promocao || ''}
            style={{ width: 120 }}
            name="valor_promocao"
            id="valor_promocao"
            color="#333333"
            label="Valor Promoção"
            variant="outlined"
            size="small"
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <FrTextInput
            value={data.valor_pag || ''}
            style={{ width: 100 }}
            name="valor_pag"
            id="valor_pag"
            color="#333333"
            label="Valor Pago"
            variant="outlined"
            size="small"
            disabled
          />

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Contas_Receber;